import { IconButton, IOption, Menu } from "@evergis/ui";
import React, { Dispatch, FC, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

import { StyledPopup } from "../../../../components/Dialogs/EditResource/components/QueryLayerResource/styled";

import { useToggle } from "../../../../hooks/useToggle";

export interface AddressProviderSelectProps {
  providerName?: string;
  setProviderName: Dispatch<SetStateAction<string>>;
  providerOptions: IOption[];
}

export const AddressProviderSelect: FC<AddressProviderSelectProps> = ({ setProviderName, providerOptions }) => {
  const { t } = useTranslation("mapControls");
  const [isVisiblePopup, togglePopup] = useToggle(false);
  const [selectedOptions, setSelectedOptions] = useState([]);

  return (
    <StyledPopup
      isVisible={isVisiblePopup}
      onRequestClose={togglePopup}
      anchor={ref => <IconButton innerRef={ref} onClick={togglePopup} kind={isVisiblePopup ? "reduce" : "expand"} />}
      placement={"bottom-start"}
    >
      <Menu
        options={providerOptions}
        multiple={false}
        selectedOptions={selectedOptions}
        selectOption={([option]) => {
          setProviderName(option.value);
          setSelectedOptions([option]);
        }}
      />
    </StyledPopup>
  );
};
